'use strict';

export default class Hero {
  constructor() {
    this.name = 'hero';
    console.log('%s module', this.name.toLowerCase());
  }
}
